import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_5q1kwycuyw: FaireBrandEntity = {
  token: "b_5q1kwycuyw",
  type: "brand",
  name: "CE Craft Co",
  avatarUrl:
    "https://cdn.faire.com/fastly/8199a98762e7751ed142cc6d9ce60efd9e8fc2d0eac7b2eff400585fc5800653.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/d028c38ea7b682261b1cde149ee6deea59bb2630bf518885335046b8147f0aef.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/8199a98762e7751ed142cc6d9ce60efd9e8fc2d0eac7b2eff400585fc5800653.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d028c38ea7b682261b1cde149ee6deea59bb2630bf518885335046b8147f0aef.jpeg",
  location: "COLLEGEVILLE, PA, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 157,
  isTopShop: true,
  isInsider: true,
  description:
    "CE Craft Co is a home fragrance company owned and operated by us, Chris & Eryn. We believe that all natural, high quality products are an essential part of any home. We strive to create high-quality products at reasonable price points for everyone.\n\nWe are dedicated to crafting all natural 100% soy wax candles, we manufacture everything in house with premium fragrance oils and non-toxic ingredients sourced from the US. Our uniquely scented candles are hand-poured in small batches, so you know they're made just for you. Covering pop culture, life’s milestones, holidays and everything in between, we strive to make unique gifts for every person and every occasion  Available in a variety of fragrances, sizes and labels there is sure to be something for everyone.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:52:25.322Z",
    importedBy: "entity-db-cli",
  },
};
